<template>
  <div>
    <info ref="header" :code="code" :disabled="disabled" />
    <detail-table :code="code" />
  </div>
</template>
<script>
import Info from "./info/index.vue"
import detailTable from "./table"
export default {
  props: {
    code: String,
    disabled: Boolean,
  },
  components: { Info, detailTable },
}
</script>
